import { gsap } from 'gsap'

export class FormEntry {
  constructor() {
    if (document.querySelector('.c-form') === null) return
    const trgList = Array.prototype.slice.call(document.querySelectorAll('.js-entry_trg'), 0)
    const targetList = Array.prototype.slice.call(document.querySelectorAll('.js-entry_target'), 0)

    trgList.forEach(function (target) {
      let radioArr = target.querySelectorAll(`input[type='radio']`)
      radioArr.forEach(function (el) {
        el.addEventListener('change', () => {
          gsap.to('.js-entry_target', 0.5, { display: 'none' })
          for (let i = 0; i < el.value; i++) {
            gsap.to(targetList[i], 0.5, { display: 'flex' })
          }
        })
      })
    })
  }
}
